/**
 * Shared styles for the "accordion-of-cards" pattern used wherever a stage's
 * data is broken into collapsible sub-sections: DiscoveryEvalForm's 8
 * sections, SubmissionDetailPage's Submission Details sub-sections, and
 * PreviousStagesPanel's per-stage items. Pair with `AppAccordionSection`
 * (components/common) for the per-item header + panel JSX.
 */

import { makeStyles, tokens } from '@fluentui/react-components';
import { brand } from './colors';

export const useAccordionCardStyles = makeStyles({
  accordionRoot: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalM,
  },
  accordionItem: {
    backgroundColor: tokens.colorNeutralBackground1,
    borderRadius: tokens.borderRadiusMedium,
    borderTopWidth: '1px',
    borderRightWidth: '1px',
    borderBottomWidth: '1px',
    borderLeftWidth: '1px',
    borderTopStyle: 'solid',
    borderRightStyle: 'solid',
    borderBottomStyle: 'solid',
    borderLeftStyle: 'solid',
    borderTopColor: tokens.colorNeutralStroke2,
    borderRightColor: tokens.colorNeutralStroke2,
    borderBottomColor: tokens.colorNeutralStroke2,
    borderLeftColor: tokens.colorNeutralStroke2,
    overflow: 'hidden',
  },
  // Header border separates title from panel content (matches CardHeader style)
  accordionHeader: {
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: tokens.colorNeutralStroke2,
  },
  // Red accent bar + title row (matches monitoring app SectionHeading pattern)
  sectionAccentRow: {
    display: 'flex',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalS,
    width: '100%',
  },
  sectionAccent: {
    flexShrink: 0,
    width: '4px',
    alignSelf: 'stretch',
    minHeight: '1.1rem',
    backgroundColor: brand.red,
    borderRadius: tokens.borderRadiusSmall,
  },
  panelContent: {
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalL}`,
  },
});
